import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '@tytapp/common';
import { UserService } from '@tytapp/user';

@Component({
  selector: 'tyt-player-banner',
  templateUrl: './player-banner.component.html',
  styleUrls: ['./player-banner.component.scss']
})
export class PlayerBannerComponent implements OnInit {

  @Input()
  isVodPremium: boolean;

  @Input()
  productionId;

  @Input()
  vodId;

  messageContent = `<span style='font-weight: bold;'>Become a member now.</span>`;

  _customText: string;

  @Input()
  get customText(): string {
    return this._customText;
  }

  set customText(value: string) {
    this._customText = value;

    if(value != null) {
      this.messageContent = `Get More <span style='font-weight: bold;'>${value} now.</span>`;
    }
  }

  constructor(
    private appConfig : AppConfig,
    private userService: UserService
  ) { }

  defaultOfferLink = "#";

  ngOnInit() {
    this.defaultOfferLink = this.appConfig.purchaseUrl;
  }

  isVisible = true;

  dismiss(event) {
    event.preventDefault();
    if(this.isVodPremium === false) {
      this.isVisible = false;
    }
  }

  bannerClick() {
    if(this.productionId != null && this.vodId != null)
      this.userService.source = `vod:lower-third:${this.productionId}:${this.vodId}`;
  }

}
